<template>
  <div>
    <LoadingOverlay v-if="isFetching" />
    <div v-if="showCampaignQuestions">
      <div
        v-if="!isFetching && (!campaign?.campaign_id || !campaign?.is_active)"
        class="text-center mt-5"
      >
        <div class="card shadow-sm p-4 mx-auto" style="max-width: 420px">
          <h3 class="mb-3">No Campaign Found</h3>
          <button class="btn btn-primary mt-2" @click="goHome">Home</button>
        </div>
      </div>
      <div v-else class="row justify-content-center">
        <div class="col-12 d-flex justify-content-end mb-3">
          <button class="btn btn-primary" @click="goHome">Home</button>
        </div>
        <div class="col-lg-6 col-md-9">
          <div class="card shadow p-4 p-md-5">
            <div class="text-center mb-4">
              <img
                v-if="logoImage"
                :src="logoImage"
                class="img-fluid mb-2"
                style="max-width: 120px"
                @error="$event.target.src = '/img/tflogo.png'"
              />

              <h2 class="fw-bold">{{ campaign?.campaign_name }}</h2>

              <p v-if="campaign?.welcome_text" class="text-muted mb-0">
                {{ campaign?.welcome_text }}
              </p>
            </div>

            <div v-if="dynamicFields.length">
              <DynamicForm
                :dynamicFields="dynamicFields"
                :candidateData="candidateData"
                @callBack="submitResponse"
                @cancelCallBack="goHome"
              />
            </div>
            <div v-else>
              <p class="text-center text-muted">No Questions Found for this Campaign.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CampaignLogin v-else-if="!campaignCandidateLoading" @proceedWithCampaignQuestions="proceedWithCampaignQuestions"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DynamicForm from "@/components/reusable/DynamicForm.vue";
import LoadingOverlay from "../../LoadingOverlay.vue";
import { BASE_URL } from "@/service_urls";
import CampaignLogin from "./CampaignLogin.vue";

export default {
  name: "CandidateCampaign",
  components: {
    DynamicForm,
    LoadingOverlay,
    CampaignLogin
  },

  data() {
    return {
      isFetching: false,
      candidateData: {},
      preRegId: null,
      showCampaignQuestions: false,
      campaignCandidateLoading: true
    };
  },

  computed: {
    ...mapGetters([
      "getCampaignById",
      "getCampaignFields",
      "getCustomerId",
      "getOrgIDFromAccessToken",
      "getQuestions",
      "getCandidateId",
      "getCampaignCandidateResponses"
    ]),
    campaign() {
      return this.getCampaignById || {};
    },
    logoImage() {
      return this.campaign?.uuid_logo_link_to_doc
        ? `${BASE_URL}${this.campaign.uuid_logo_link_to_doc.replace(
            "/api/v1",
            ""
          )}?file=logo`
        : null;
    },
    dynamicFields() {
      return this.getCampaignCandidateResponses?.questions || this.getQuestions || [];
    },
  },

  methods: {
    ...mapActions([
      "fetchCampaignById",
      "fetchCampaignFields",
      "createCampaignTransactions",
      "fetchQuestions",
      "createCampaignPreScreenTransaction",
      "fetchCampaignCandidateTransaction",
      "addCampaignCandidate"
    ]),
    async loadCampaign() {
      const { campaign_id: campaign_uuid } = this.$route.params;
      this.isFetching = true;

      try {
        const response = await this.fetchCampaignById(campaign_uuid);
        const { campaign_id } = response;

        try {
          await this.fetchCampaignCandidateTransaction({
            campaign_id,
            candidate_uid: this.getCandidateId,
          });
        } catch (err) {
          console.warn(
            "fetchCampaignCandidateTransaction failed, loading questions instead",
            err
          );
        }

        if (this.getCampaignCandidateResponses?.questions?.length) {
          return;
        }
        if (campaign_id) {
          await this.fetchQuestions({
            customer_uid: this.getCustomerId,
            query: {
              organisation_id: this.getOrgIDFromAccessToken,
              context_type: "CAMPAIGN",
              context_id: campaign_id,
            },
          });
        }
      } catch (error) {
        console.error("Error while loading campaign", error);
      } finally {
        this.isFetching = false;
      }
    },
    goHome() {
      this.$router.push(`/home?tab=5`);
    },
    formatResponses(data) {
      return data.map((field) => ({
        customer_uid: this.getCustomerId,       
        organisation_id: this.getOrgIDFromAccessToken, 

        question_id: field.field_id,
        yes_no_response: field.answer.yes_no_response,
        numeric_response: field.answer.numeric_response,
        text_area_response: field.answer.text_area_response,
        rating_count: field.answer.rating_count,
        date_response: field.answer.date_response,
        options_response: field.answer.options_response || []
      }));
    },
    async submitResponse(data) {
      const payload  = this.formatResponses(data);
      await this.createCampaignPreScreenTransaction({
        customer_uid: this.getCustomerId,
        campaign_id: this.getCampaignById?.campaign_id,
        candidate_uid: this.getCandidateId,
        payload
      });
      localStorage.removeItem("campaignID");
      this.goHome();
    },
    proceedWithCampaignQuestions(value) {
      this.showCampaignQuestions = value;
    }
  },
  async mounted() {
    await this.loadCampaign();
      if (!this.showCampaignQuestions) {
        this.campaignCandidateLoading = true;
        await this.addCampaignCandidate({
          campaign_id: this.getCampaignById?.campaign_id
        });
        this.campaignCandidateLoading = false;
      }
  },
};
</script>

<style scoped>
.card {
  border-radius: 14px;
}

img {
  object-fit: contain;
}
</style>
